export default {
  version: 'Historique',
  attributes: {
    version: {
      created_at: 'Date',
      event: 'Action',
      objectChanges: 'Changements',
      user: 'Responsable',
      events: {
        create: 'Création',
        update: 'Mise à jour',
        destroy: 'Suppression',
        restore: 'Rétablir',
      },
    },
  },
};
